import { Link } from "react-router-dom";
import { LegalPageLayout } from "../components/layout/LegalPageLayout";
import { SEO } from "../components/seo/SEO";

export default function Support() {
  return (
    <>
      <SEO
        title="Support | Equna"
        description="Hilfe und Kontakt für Equna – gemeinsame Ausgaben fair teilen."
        canonical="/support"
      />
      <LegalPageLayout title="Support & Hilfe">
        <div className="space-y-8">
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">
              Kontakt
            </h2>
            <p className="text-slate-600 leading-relaxed">
              Bei Fragen, Problemen oder Feedback erreichst du uns per E-Mail:
            </p>
            <p className="text-slate-600 mt-2">
              <a
                href="mailto:contact@equna.eu"
                className="text-emerald-600 hover:text-emerald-700 transition-colors font-medium text-lg"
              >
                contact@equna.eu
              </a>
            </p>
            <p className="text-slate-500 text-sm mt-2">
              Wir antworten in der Regel innerhalb von 24 Stunden.
            </p>
          </section>

          <section>
            <p className="text-slate-600 leading-relaxed">
              Antworten auf häufige Fragen findest du in unserer{" "}
              <Link to="/#faq" className="text-emerald-600 hover:text-emerald-700 font-medium">
                FAQ
              </Link>.
            </p>
          </section>
        </div>
      </LegalPageLayout>
    </>
  );
}
